import name from './name'

const selectSliceData = state => state[name]

const selectFreeAccountCtaOpen = state => selectSliceData(state).open
const selectFreeAccountCtaMessage = state => selectSliceData(state).message
const selectAppendSubscribeFreeNewsletterParam = state => selectSliceData(state).appendSubscribeFreeNewsletter

export { selectFreeAccountCtaOpen, selectFreeAccountCtaMessage, selectAppendSubscribeFreeNewsletterParam }
